import { render, staticRenderFns } from "./cost-info.vue?vue&type=template&id=48d4cde1&scoped=true&"
import script from "./cost-info.vue?vue&type=script&lang=js&"
export * from "./cost-info.vue?vue&type=script&lang=js&"
import style0 from "./cost-info.vue?vue&type=style&index=0&id=48d4cde1&lang=scss&scoped=true&"
import style1 from "./cost-info.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4cde1",
  null
  
)

export default component.exports